import React from 'react';
import buildVersion from '../../utils/appVersion';

function VersionBadge() {
  const label = buildVersion?.label || 'dev';

  return (
    <div
      className="pointer-events-none fixed bottom-2 right-2 z-[5] select-none font-mono text-[10px] leading-none tracking-tight text-secondary-400/25  sm:bottom-3 sm:right-3 sm:text-[11px]"
      aria-hidden="true"
      title={`${label} (${buildVersion?.branch || 'unknown'})`}
    >
      {label}
    </div>
  );
}

export default VersionBadge;
